module.exports = __webpack_public_path__ + "img/construction.30a77834.svg";